import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Solutions from "../pages/solutions/page";
import Contact from "../pages/contact/page";
import About from "../pages/about/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfUse from "../pages/terms/page";
import Partners from "../pages/partners/page";
import Security from "../pages/security/page";
import Compliance from "../pages/compliance/page";
import FAQPage from "../pages/faq/page";
import AdminContacts from "../pages/admin/contacts/page";
import ApplyPage from "../pages/apply/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfUse />,
  },
  {
    path: "/partners",
    element: <Partners />,
  },
  {
    path: "/security",
    element: <Security />,
  },
  {
    path: "/compliance",
    element: <Compliance />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/admin/contacts",
    element: <AdminContacts />,
  },
  {
    path: "/apply",
    element: <ApplyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
